export default {
  cartItems: JSON.parse(localStorage.getItem('cartItems')) || [],
  isSideCartVisible: false,
}
